import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Button, Group, Modal, Text } from "@mantine/core";
import { useNavigate } from "react-router";
export default function WordCardDeleteModal(_a) {
    var card = _a.card, show = _a.show, onClose = _a.onClose, onRemove = _a.onRemove;
    var navigate = useNavigate();
    var doRemoveCard = function () {
        fetch('/api/speech-item/' + encodeURIComponent(card === null || card === void 0 ? void 0 : card.uuid) + '/remove', {
            method: 'POST'
        })
            .then(function (res) {
            if (res.status === 401) {
                navigate('/login');
                return;
            }
            if (res.status === 404) {
                navigate('/404');
                return;
            }
            onRemove(card === null || card === void 0 ? void 0 : card.uuid);
            onClose();
        });
    };
    return _jsxs(Modal, { opened: show, onClose: onClose, title: "Remove Word", centered: true, size: "sm", styles: {
            title: { fontWeight: 700 }
        }, closeButtonProps: { 'aria-label': 'Close modal' }, children: [_jsxs(Text, { size: "sm", c: "dimmed", children: ["Are you sure you want to remove \"", card === null || card === void 0 ? void 0 : card.word, "\"?"] }), _jsxs(Group, { justify: "flex-end", mt: "xl", gap: "sm", children: [_jsx(Button, { variant: "filled", color: "red", onClick: doRemoveCard, children: "Remove" }), _jsx(Button, { variant: "default", onClick: onClose, children: "Cancel" })] })] });
}
